import { h } from 'preact';
import styles from './SelectedFilters.module.scss';
import { Close } from '../icons/close';
export function SelectedFilters({ filters, onRemoveFilter, onClearAll, onPillClick, }) {
    // Collect all selected filter options
    const selectedItems = [];
    filters.forEach((filter) => {
        if (filter.options) {
            filter.options.forEach((option) => {
                if (option.selected) {
                    selectedItems.push({
                        filterId: filter.id,
                        filterLabel: filter.label,
                        optionId: option.id,
                        optionLabel: option.label,
                    });
                }
            });
        }
    });
    if (selectedItems.length === 0) {
        return null;
    }
    const handlePillClick = (filterId) => {
        // Only open drawer on mobile (width <= 1200px)
        if (onPillClick && window.innerWidth <= 1200) {
            onPillClick(filterId);
        }
    };
    return (h("div", { class: styles.selectedFilters }, selectedItems.map((item) => (h("div", { key: `${item.filterId}-${item.optionId}`, class: styles.filterPill, onClick: () => handlePillClick(item.filterId) },
        h("span", { class: styles.filterPillLabel }, item.optionLabel),
        h("button", { class: styles.removeButton, onClick: (e) => {
                e.stopPropagation();
                onRemoveFilter(item.filterId, item.optionId);
            }, "aria-label": `Remove ${item.optionLabel} filter` },
            h(Close, null)))))));
}
